import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { IEvent } from '@/utils/types/Event'

export default function useSeo(event: IEvent) {
  const globalStore = useGlobalStore()
  globalStore.setBreadcrumbs([{ title: '活動報名', isActive: false, url: '/events' }])

  const title = `${event?.seo?.meta_title || event.subject}｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = event?.seo?.og_description

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: event?.seo?.og_image?.link
  })
  useHead({
    link: [
      {
        rel: 'canonical',
        href: event?.seo?.canonical || `${import.meta.env.VITE_DOMAIN}/events/${event?.seo?.meta_slug || event?.id}`
      }
    ]
  })
  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '活動報名',
            item: `${import.meta.env.VITE_DOMAIN}/events`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: event?.subject,
            item: `${import.meta.env.VITE_DOMAIN}/events/${event?.seo?.meta_slug || event?.id}`
          }
        ]
      }
    ]
  })
}
